<template>
    <div id="trx-basic-2-container">
      <f7-list form class="form-group" v-show="showFormSet.collection">
  
        <f7-list-input
            input-id     ="identificationType"
            name         ="identificationType"
            type         ="text"

            v-show        ="showFormInput.root.identificationType"
            :label       ="$t('beneficiary-beneficiary-id-type')"
            :placeholder ="$t('beneficiary-beneficiary-id-type')"
            :value       ="identificationType"
            @input       ="setIdentificationType($event.target.value); validateInput($event.target); setInput($event.target)"

            maxlength    ="50"
            outline
            floating-label
            clear-button
        ></f7-list-input>

        <f7-list-input
            input-id     ="idTypeSelect"
            name         ="idTypeSelect"
            class        ="clickable-row use-chevron"

            v-show       ="showFormInput.root.idTypeSelect"
            :label       ="$t('beneficiary-beneficiary-id-type')"
            :placeholder ="$t('beneficiary-select-beneficiary-id-type')"
            :value       ="idTypeSelect"
            @change      ="setIdTypeSelect($event.target.value);"

            outline
            floating-label
        >
            <f7-link popover-open=".popover-dropdown-id-type" slot="content-start" class="clickable-item"></f7-link>
        </f7-list-input>

        <f7-popover class="popover-dropdown-id-type dropdown-default dropdown" :backdrop="true">
            <f7-list>
                <f7-list-item popover-close link="#"
                v-for="(it, key) in idTypeList"
                :key="key"
                selected=""
                @click="changeIdType(key); validateInput($event.target); setInput('idTypeSelect');">
                  {{it}}
                </f7-list-item>
            </f7-list>
          </f7-popover>

        <f7-list-input
            input-id     ="identificationNo"
            name         ="identificationNo"
            type         ="text"

            :label       ="$t('beneficiary-beneficiary-id-no')"
            :placeholder ="$t('beneficiary-beneficiary-id-no')"
            :value       ="identificationNo"
            @input       ="setIdentificationNo($event.target.value); validateInput($event.target); setInput($event.target)"

            maxlength    ="30"
            autocomplete ="off"
            outline
            floating-label
            clear-button
        ></f7-list-input>
    </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('transaction', [
          'showFormSet',
          'showFormInput',
          'identificationTypeLabel',
          'identificationType',
          'idTypeSelect',
          'idTypeSelectId',
          'idTypeList',
          'identificationNoLabel',
          'identificationNo',
      ])
    },
    methods: {
      ...mapActions('transaction', [
          'setIdentificationType',
          'setIdTypeSelect',
          'setIdentificationNo',
      ]),

      changeIdType(id){
        this.$emit("changeIdType", id);
      },
      
      validateInput(inputEl){
        this.$emit("validateInput", inputEl);
      },

      setInput(inputEl){
        this.$emit("setInput", inputEl);
      }

    }
  }
</script>
